import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje, MensajeSiNo } from "../components/mensajes";
import { Loader, Dimmer } from "semantic-ui-react";
import useTable from "../components/useTable";
import { TableBody, TableRow, TableCell } from "@material-ui/core";
import axios from "axios";
import { formatMoneda } from "../util/varios";
import moment from "moment";

const CatalogoNotaEntregaFacturas = (props) => {
  let op = require('../../public/modulos/datos');
  let token = sessionStorage.getItem('jwtToken');
  const btnAcepta = useRef();
  const btnCancela = useRef();
  const txtBuscar = useRef();
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [records, setRecords] = useState([]);
  const [values, setValues] = useState([]);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const headCells = [
    { label: "SELECCIONAR", textAlign: "center" },
    { label: "CODIGO", textAlign: "center" },
    { label: "N° NOTA ENTREGA", textAlign: "center" },
    { label: "FECHA", textAlign: "center" },
    { label: "NOMBRE DEL CLIENTE", textAlign: "center" },
    { label: "STATUS", textAlign: "center" },
  ];

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;

    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              x.idnotaentrega.includes(target.value) ||
              x.numnotaentrega
                .toLowerCase()
                .includes(target.value.toLowerCase()) ||
              moment(x.fecha)
                .format("DD-MM-YYYY")
                .toLowerCase()
                .includes(target.value.toLowerCase()) ||
              x.clientec.toLowerCase().includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
        }
      },
    });
  };

  const seleccionarRegistros = () => {
    let endpoint = `${op.conexion}/api/registropago/selectnotaentregafactucat`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            setRecords(response.data);
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  const blanquear = () => {
    setActivate(false);
    setRecords([]);
    setValues([]);
    setFilterFn({
      fn: (items) => {
        return items;
      },
    });
    setSeleccionados([]);
    setSeleccionadosc([]);
  };

  const cancelar = () => {
    blanquear();
    props.onHideCancelar();
  };

  const seleccionarProducto = () => {
    props.onHideAceptaCatalogo(values);
  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const handleCloseNo = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const [seleccionados, setSeleccionados] = useState([]);
  const [seleccionadosc, setSeleccionadosc] = useState([]);

  const handleCheckboxChange = (item) => (e) => {
    const isChecked = e.target.checked;
    const notaId = item.idnotaentrega;
    const clienteId = item.idcliente;

    if (isChecked) {
      if (seleccionados.length > 0 && !seleccionadosc.includes(clienteId)) {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "¡Solo puede seleccionar múltiples notas de un mismo Cliente!",
          icono: "informacion"
        });
        return;
      }
      setSeleccionados([...seleccionados, notaId]);
      if (seleccionados.length === 0) {
        setSeleccionadosc([clienteId]);
      }
      setValues([...values, {
        idnota: notaId,
        idcliente: clienteId,
        cliente: item.clientec,
        direccion: item.direccionclientec,
        rif: item.rifcliente
      }]);
    }
    else {
      const newSeleccionados = seleccionados.filter(id => id !== notaId);
      setSeleccionados(newSeleccionados);

      setValues(values.filter(v => v.idnota !== notaId));

      const quedanNotasDeEsteCliente = newSeleccionados.some(id => {
        const nota = records.find(n => n.idnotaentrega === id);
        return nota.idcliente === clienteId;
      });

      if (!quedanNotasDeEsteCliente) {
        setSeleccionadosc([]);
      }
    }
  };

  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        blanquear();
        txtBuscar.current.focus();
        seleccionarRegistros();
      }}
    >
      <Modal.Header className="azulGradiant2 header-modal">
        <div className="fw-bold text-light">
          <h3>
            Seleccionar {props.tipo === "ND" ? "Nota de Debito" : "Precuenta"}
          </h3>
        </div>
        <button
          ref={btnCancela}
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <Mensaje
          mensaje={mensaje}
          onHide={() =>
            setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
        />
        <MensajeSiNo
          mensaje={mensajesino}
          onHideNo={handleCloseNo}
          onHideSi={handleCloseSi}
        />
        <Dimmer active={activate} inverted>
          <Loader inverted>Cargando...</Loader>
        </Dimmer>
        <div className="col-md-12" style={{ marginBottom: "10px" }}>
          <div className="row">
            <div className="input-group col-md-8 input-group-sm mb-3">
              <input
                type="text"
                ref={txtBuscar}
                onChange={handleSearch}
                className="form-control"
              />
              <button
                className="btn btn-info"
                style={{ pointerEvents: "none" }}
              >
                <i className="fa fa-search"></i>
              </button>
            </div>
          </div>
        </div>
        <div className="col-md-12" style={{ margin: "auto" }}>
          <TblContainer>
            <TblHead />

            <TableBody>
              {records &&
                recordsAfterPagingAndSorting().map((item, index) => (
                  <TableRow
                    key={index}
                    style={{
                      padding: "0",
                    }}
                  >
                    <TableCell className="py-2 text-center">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          checked={seleccionados.includes(item.idnotaentrega)}
                          onChange={handleCheckboxChange(item)}
                          type="checkbox"
                          id="flexCheckDefault"
                          disabled={
                            seleccionados.length > 0 &&
                            !seleccionados.includes(item.idnotaentrega) &&
                            !seleccionadosc.includes(item.idcliente)
                          }
                        />
                      </div>
                    </TableCell>
                    <TableCell className="py-2 text-center">
                      {item.idnotaentrega}
                    </TableCell>
                    <TableCell className="py-2 text-center">
                      {item.numnotaentrega}
                    </TableCell>
                    <TableCell className="py-2 text-center">
                      {moment(item.fecha).format("DD-MM-YYYY")}
                    </TableCell>
                    <TableCell className="py-2 text-start">
                      {item.clientec}
                    </TableCell>
                    <TableCell className="py-2 text-start">
                      {item.status === 1 ? "PAGADA" : "POR PAGAR"}
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </TblContainer>
          <TblPagination />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          ref={btnAcepta}
          className="btn btn-sm btn-success rounded-pill"
          style={{ margin: "5px" }}
          onClick={seleccionarProducto}
        >
          <i className="fas fa-check-circle"> Aceptar</i>{" "}
        </button>
        <button
          ref={btnCancela}
          onClick={cancelar}
          className="btn btn-sm btn-danger rounded-pill"
        >
          <i className="fas fa-window-close"> Cancelar</i>
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default CatalogoNotaEntregaFacturas;



// WEBPACK FOOTER //
// ./src/catalogos/catalogoNotaEntregaFactura.js